module.exports = __webpack_public_path__ + "img/maisonette-13.a18effcc.webp";